
import { TicketReplyTemplate } from "@/models/ticket-reply-template";
import { ISelectItem } from "winfakt-vue-components/src/classes";
import Vue from "vue";
import { Ticket } from "@/models/ticket";
import {IntegromatService} from "@/utils/services/integromat";
import {AuthService} from "@/services/auth-service";
import {Admin} from "@/models/admin";
export default Vue.extend({
	data(){
		return {
			loaded: false,
			templates: [] as TicketReplyTemplate[],
		};
	},
	props: {
		ticket: {
			type: Object as ()=>Ticket,
			required: true
		}
	},
	computed: {
		items():ISelectItem<TicketReplyTemplate>[]{
			return this.templates.map(t=>{
				return {
					text: t.name,
					value: t
				};
			});
		},
		disabled():boolean{
			return this.templates.length == 0;
		}
	},
	methods: {
		async onClick(item:TicketReplyTemplate){
			// TODO: Use enum for event id
			console.log(item.eventId, this.ticket.company);
			if (item.eventId == 1 && this.ticket.company && this.ticket.company.hasWrittenReview){
				let confirm = await this.$wf.confirm("Deze klant heeft al een review geschreven. Weet u zeker dat u wilt doorgaan?", "Ja", "Nee", "Warning");
				if (!confirm) return;
			}

			if(item.triggerHook){
				let admin = AuthService.user ? AuthService.user : new Admin({});
				await IntegromatService.triggerAutoEmailHook(this.ticket,item.name,item.eventId, admin);
				this.$wf.notify("Automatisch bericht verzonden", "success", 3000, "check");
			}else{
				this.$emit("add-text", item);
			}

			this.$emit("close");


		},
		cancel(){
			this.$emit("close");
		}
	},
	async created(){
		//this.templates = await TicketService.getReplyTemplates();
		this.templates = await IntegromatService.getAutoEmailTemplates();
		this.loaded = true;
	}
});
